import { DSTopicPage, LinkedLinkProps } from 'shared-definitions/types'
import { ApiPageTopicNestedProps, ApiPageTopicProps } from 'data-source/types.wp'
import { PLinkMapperOpts } from './pLinkMapper'
import { headPropsMapper } from './headPropsMapper'
import { htmlMapper } from './htmlMapper'
import { metaMapper, MetaMapperOpts } from './metaMapper'
import { sluggedLinkMapper } from './sluggedLinkMapper'
import { paginatedCategoryMapper } from './paginatedCategoryMapper'

interface TopicCodecOpts extends PLinkMapperOpts, MetaMapperOpts {
  authorLinkBuilder: (slug: string) => LinkedLinkProps
}

export function codecGetTopicPage(
  input: ApiPageTopicProps | ApiPageTopicNestedProps,
  opts: TopicCodecOpts
): DSTopicPage {
  return {
    resource: 'topic-page',
    head: headPropsMapper(input.head),
    sections: null,
    pagePath: opts.postLinkBuilder(input.slug).href,
    ampPagePath: null,
    meta: metaMapper({ ...input, categories: [], tags: [] }, [input.title], opts),
    slug: input.slug,
    title: input.title,
    subTitle: input.subtitle,
    html: htmlMapper(input.description),
    breadcrumbs: input.breadcrumbs.map(i => sluggedLinkMapper(i, opts)),
    topics: input.topics.length
      ? {
          title: 'Go deeper',
          items: input.topics.map(i => sluggedLinkMapper(i, opts)),
        }
      : null,
    categories: input.categories
      .filter(i => i.posts.content.total_posts > 0)
      .map(i => ({
        title: i.title,
        posts: paginatedCategoryMapper(i.posts, opts),
      })),
    latest: {
      title: 'All the latest',
      shortTitle: 'All',
      items: paginatedCategoryMapper(input.latest, opts),
    },
    news:
      'news' in input
        ? {
            title: `${input.title} news`,
            shortTitle: 'News',
            items: paginatedCategoryMapper(input.news, opts),
          }
        : null,
  }
}
